import {ComponentStyleConfig} from '@chakra-ui/react';

export const Badge: ComponentStyleConfig = {
  baseStyle: {},
  variants: {
    notification: {
      backgroundColor: 'error.300',
      color: 'error.900',
      borderRadius: 'xl',
      visibility: 'hidden',
      width: '20px',
      height: '20px',
      overflow: 'hidden',
      display: 'flex',
      flexFlow: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '12px'
    }
  }
};
